module.exports = __webpack_public_path__ + "static/img/info-welfare.99a8b144.png";